import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { ModalService } from '@spartacus/storefront';
import { SdvorPickupMapSelectPosComponent } from '../pickup-map-select-pos/pickup-map-select-pos.component';

@Component({
  selector: 'sd-pickup-add-shop',
  templateUrl: './pickup-add-shop.component.html',
  styleUrls: ['./pickup-add-shop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupAddShopComponent {
  @Input() text: string;

  iconType = CUSTOM_ICON_TYPE;

  constructor(private modalService: ModalService) {}

  openModal(): void {
    this.modalService.open(SdvorPickupMapSelectPosComponent, {
      centered: true,
      size: 'xl',
      modalDialogClass: 'modal-rounded',
    });
  }
}
